import { useState } from 'react';
import get from 'lodash/get';
import { PageTemplateProps } from 'types/pages';
import PageBackground from 'components/atoms/PageBackground/PageBackground';
import { ButtonQrScan } from 'components/molecules/ButtonQrScan';
import { HeaderGuide } from 'components/organisms/HeaderGuide';
import { QrScanModal } from 'components/organisms/QrScanModal';
import { Footer } from 'components/organisms/Footer';
import { HeaderSpacerGuide } from 'components/atoms/HeaderSpacer';
import ComponentsRenderer from './partials/ComponentsRenderer';
import TemplateWrapper from './partials/TemplateWrapper';

const GuideTemplate: React.FC<PageTemplateProps> = ({ header, data, footer }) => {
  const { alternate_languages } = data;

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return (
    <TemplateWrapper pageId={data.id} data={data}>
      <HeaderGuide meta_links={header.data.meta_links} alternateLanguages={alternate_languages} />
      <HeaderSpacerGuide />
      <PageBackground />
      <ComponentsRenderer slices={get(data, 'data.body', [])} />
      <Footer data={get(footer, 'data.body', [])} />
      {isModalOpen && (
        <QrScanModal
          onCloseCallback={() => {
            setIsModalOpen(false);
          }}
        />
      )}
      <ButtonQrScan
        onClickCallback={() => {
          setIsModalOpen(true);
        }}
      />
    </TemplateWrapper>
  );
};

export default GuideTemplate;
